import React, { useState, useEffect } from "react";
import axios from "axios";
import compact from "lodash/compact";
import $ from "jquery";
const Company = ({ setDataCompany, dataCompany, isValidCompanyError, isValidCompany, setcurrent, setValidateCurrent, validateCurrent }) => {
    const [firstPass, setFirstPass] = useState(true);
    const category = [
        {
            id: "clothes_shoes_accessories",
            name: "Clothes, Shoes & Accessories",
        },
        {
            id: "food",
            name: "Beverages & Food",
        },
        {
            id: "furniture_toys",
            name: "Furniture & Toys",
        },
        {
            id: "electronics",
            name: "Eletronics",
        },
        {
            id: "foHealthcare_beautyod",
            name: "Healthcare & Beauty",
        },
        {
            id: "Gardening_Floriculture",
            name: "Gardening & Floriculture",
        },
        {
            id: "others",
            name: "Others",
        },
    ];

    useEffect(() => {
        getCity();
    }, []);

    const error = "h-8 bg-white border border-shippify-red rounded-lg outline-none mt-1 text-shippify-darkGray text-sm px-2 w-full";
    const check = "h-8 bg-white border rounded-lg outline-none mt-1 text-shippify-darkGray text-sm px-2 w-full";

    function handleChange({ target }) {
        setFirstPass(false);
        const { name, value } = target;
        setDataCompany({
            ...dataCompany,
            [name]: value,
        });
    }
    function validate() {
        if (isValidCompany) {
            $(".container").removeClass("");
            $("#div3").fadeOut(2000);
            // setInterval(() => {
            setcurrent("user");
            setValidateCurrent({
                ...validateCurrent,
                company: true,
            });
            // }, 1000);
        } else {
            setFirstPass(false);
        }
    }
    function getCity() {
        axios
            // .get(`http://localhost:8030/operator/filters/noAuth/countries`)
            .get(`https://dash.shippify.co/operator/filters/noAuth/countries`)
            .then((response) => {
                console.log("response - country", response);

                var citiesArray = response.data.payload.data.filters.countries;
                compact(
                    citiesArray.map((item) => {
                        if (item.isVisible === 1) {
                            var city = { value: item.id, label: item.name };
                            $("#city").append(
                                $("<option>", {
                                    value: item.id,
                                    text: item.name,
                                })
                            );
                            return city;
                        }
                        return null;
                    })
                );
                if(dataCompany && dataCompany.city){
                    $("#city option[value="+dataCompany.city+"]").prop("selected", "selected")
                }
            })
            .catch((err) => console.error("err", err));
    }

    return (
        <div className="h-form flex flex-col justify-between fade-in container">
            <div className="flex flex-col">
                <div className="flex mt-4">
                    <div className="flex-col w-full">
                        <div className="flex flex-col w-full">
                            <span className="text-xs text-shippify-gray"> Company name </span>
                            <input
                                type="text"
                                className={!firstPass && isValidCompanyError.name ? error : check}
                                name="name"
                                onChange={(e) => handleChange(e)}
                                value={dataCompany.name}
                            />
                            <span className="text-shippify-red text-s visible h-4 leading-none mt-1">{!firstPass && isValidCompanyError.name}</span>
                        </div>
                        <div className="flex flex-col w-full">
                            <span className="text-xs text-shippify-gray"> Country </span>
                            {/* {cities && (
                            <Select
                                name="city"
                                options={cities}
                                // value={citySelected}
                                onChange={(e) => handleChange(e)}
                                styles={citySelected ? error : check}
                            />
                        )} */}
                            <select
                                name="city"
                                id="city"
                                value={dataCompany.city}
                                onChange={(e) => handleChange(e)}
                                className={!firstPass && isValidCompanyError.city ? error : check}></select>
                            <span className="text-shippify-red text-s visible h-4 leading-none mt-1">{!firstPass && isValidCompanyError.city}</span>
                        </div>
                    </div>
                </div>
                <div className="flex">
                    <div className="flex-col w-full">
                        <div className="flex flex-col w-full">
                            <span className="text-xs text-shippify-gray"> Category </span>
                            <select
                                type="text"
                                className={!firstPass && isValidCompanyError.category ? error : check}
                                name="category"
                                onChange={(e) => handleChange(e)}
                                value={dataCompany.category}>
                                <option defaultValue> Select your category </option>
                                {category.map((key, value) => {
                                    return (
                                        <option key={value} value={key.id}>
                                            {key.name}
                                        </option>
                                    );
                                })}
                            </select>
                            <span className="text-shippify-red text-s visible h-4 leading-none mt-1">
                                {!firstPass && isValidCompanyError.category}
                            </span>
                        </div>
                        <div className="flex flex-col w-full">
                            <span className="text-xs text-shippify-gray"> Delivery/month </span>
                            <select
                                type="text"
                                className={!firstPass && isValidCompanyError.delivery ? error : check}
                                name="delivery"
                                onChange={(e) => handleChange(e)}
                                value={dataCompany.delivery}>
                                <option defaultValue> Select how many deliveries per month you will make </option>
                                <option> 1 to 100 Delivery/month </option>
                                <option> 100 to 1000 Delivery/month </option>
                                <option> 1000+ Delivery/month </option>
                            </select>
                            <span className="text-shippify-red text-s visible h-4 leading-none mt-1">
                                {!firstPass && isValidCompanyError.delivery}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end w-full">
                <div
                    className="rounded-full bg-shippify-green text-white px-6 h-8 outline-none flex justify-center items-center cursor-pointer shadow-primary"
                    onClick={validate}>
                    Next step
                </div>
            </div>
        </div>
    );
};
export default Company;
